export const DAILY_LOG_TYPE_LIST = [
  {
    dailyLogTypeId: 1,
    dailyLogTypeNameEn: 'study',
    dailyLogTypeNameKo: '스터디'
  },
  {
    dailyLogTypeId: 2,
    dailyLogTypeNameEn: 'rest',
    dailyLogTypeNameKo: '휴식'
  },
  {
    dailyLogTypeId: 3,
    dailyLogTypeNameEn: 'meal',
    dailyLogTypeNameKo: '식사'
  },
  {
    dailyLogTypeId: 4,
    dailyLogTypeNameEn: 'attendance',
    dailyLogTypeNameKo: '출석'
  },
  {
    dailyLogTypeId: 5,
    dailyLogTypeNameEn: 'etc',
    dailyLogTypeNameKo: '기타'
  }
]